export default __webpack_public_path__ + "static/satellite-168243757f082d115d9cb1fce24b30d0.png";